export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            日本の職人に<br />
            ドバイボウルを<br />
            作ってもらったら<br />
            こうなりました。
          </h2>
          <p className="text-gray-600 text-xl max-w-3xl mx-auto leading-relaxed">
            「Spring Sun Bowl (ドバイボウル（ハガル）)」は、ドバイで主流のボウル形状を日本の職人技術で再現したシーシャ用器具です。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-3">形状の再現</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              ドバイで広く普及している伝統的なボウルの形をベースに、日本人の吸い心地や使いやすさに合わせて調整されています。
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-3">益子焼の素材感</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              厚みのある陶器（益子焼）で作られているため、保温性が高く、熱がじっくりと均一に伝わるのが特徴です。Spring Sun Bowlは土にこだわりを持ち、３段階の温度調整をBowlの素材で実現しています。
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-3">ハンドメイドの味わい</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              職人が一つずつ手作業で仕上げており、土のぬくもりを感じる一点ものの仕上がりになっています。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          <div className="rounded-3xl overflow-hidden shadow-lg">
            <img 
              src="https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/c704eeb1781735d8d0d65aade67731cd.png" 
              alt="職人の手元" 
              className="w-full h-80 object-cover object-top"
            />
          </div>
          <div className="rounded-3xl overflow-hidden shadow-lg">
            <img 
              src="https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/2d88f31e713b698d577cf2ec8c678133.png" 
              alt="工房の様子" 
              className="w-full h-80 object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
